import { connect } from 'react-redux'
import React from 'react'
import './index.scss'
import { userSettingsSet, userSettingsUpdateRequest } from '../../../action/user-settings-actions'
import { multiTileHuntLayers } from '../../hunt-planner/huntplanner-layer-render/renderlayerFunction'

const LayerToggle = props => {
  const { layersDictionary, leftToolbarState, mapReference, huntplannerActiveLayerPayload, userSettings, userSettingsSet, userSettingsUpdateRequest, userPreferences, selectedTab } = props,
    { selectedTopo } = userPreferences,
    leftOffset = '98px',
    storeActive = userSettings.find(setting => setting.settingId === 1),
    storeArr = storeActive && storeActive.valueArray ? storeActive.valueArray : [],
    activeBM = storeArr.find(id => layersDictionary[id] && layersDictionary[id].layerNodeId === 5),
    setBaseLayer = id => {
      const settingClone = userSettings.map(setting => Object.assign({}, setting)),
        active = settingClone.find(setting => setting.settingId === 1),
        activeArr = active && active.valueArray ? active.valueArray : [],
        activeBMLayer = layersDictionary[activeBM],
        overlay = activeBMLayer && activeBMLayer.overlayLayerId ? activeBMLayer.overlayLayerId : null,
        newBM = layersDictionary[id],
        newBase = newBM.overlayLayerId ? [id, newBM.overlayLayerId] : [id],
        newActive = newBase.concat(activeArr.filter(id => id !== activeBM && id !== overlay))

      active.value = JSON.stringify(newActive)
      active.valueArray = newActive

      userSettingsSet(settingClone)
      userSettingsUpdateRequest(1, JSON.stringify(newActive), false)
      if (selectedTab == "huntplanner") {
        setTimeout(() => {
          // console.log('this is not used pavan layer ')
          multiTileHuntLayers(
            huntplannerActiveLayerPayload.mapObj,
            huntplannerActiveLayerPayload.mapObjVal,
            huntplannerActiveLayerPayload.filter,
            huntplannerActiveLayerPayload.tile,
            huntplannerActiveLayerPayload.layerApi,
            huntplannerActiveLayerPayload.params,
            huntplannerActiveLayerPayload.layerData,
            huntplannerActiveLayerPayload.callback,
          )
        }, 1000)
      }
    }

  return (
    <div className='layer-toggle-container' style={{ left: leftOffset }}>
      <div className='layer-toggle-container-child' style={{
        right: selectedTab == "huntplanner" ? (props.huntplannerRightToolbar && !props.huntplannerMorefiltersExpand
          && !props.huntPlannerUnitRightMenuBar?.expanded
          ? '10%' : (props.huntplannerMorefiltersExpand || props.huntPlannerUnitRightMenuBar?.expanded) ? '25%' : '') :
          selectedTab == "recreationAccess" ? (props.landTrustMenuBar ? (props.lantTrustPrivateLandDetails || props.landTrustRightMenuBarObj.expanded) ? '20%' : '10%' : '') : ''
      }}>
        <div className='layer-toggle' style={{
          backgroundColor: activeBM === 81 ? '#589500' : '',
          color: activeBM === 81 ? '#FFFFFF' : ''
        }}
          onClick={() => { setBaseLayer(81) }}
        >
          <p className='center'>SAT</p>
        </div>
        <div className='layer-toggle' style={{
          backgroundColor: activeBM === 891 ? '#589500' : '',
          color: activeBM === 891 ? '#FFFFFF' : ''
        }}
          onClick={() => { setBaseLayer(891) }}>
          <p className='center'>HYB</p>
        </div>
        <div className='layer-toggle' style={{
          backgroundColor: activeBM === selectedTopo ? '#589500' : '',
          color: activeBM === selectedTopo ? '#FFFFFF' : ''
        }}
          onClick={() => { setBaseLayer(selectedTopo) }}>
          <p className='center'>TOPO</p>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = state => ({
  layersDictionary: state.layersDictionary,
  leftToolbarState: state.leftToolbarState,
  userSettings: state.userSettings,
  userPreferences: state.userPreferences,
  selectedTab: state.selectedTab,
  huntplannerActiveLayerPayload: state.huntplannerActiveLayerPayload,
  huntplannerMorefiltersExpand: state.huntplannerMorefiltersExpand,
  huntplannerRightToolbar: state.huntplannerRightToolbar,
  huntPlannerUnitRightMenuBar: state.huntPlannerUnitRightMenuBar,
  landTrustMenuBar: state.landTrustMenuBar,
  lantTrustPrivateLandDetails: state.lantTrustPrivateLandDetails,
  landTrustRightMenuBarObj: state.landTrustRightMenuBarObj
})

const mapDispatchToProps = dispatch => ({
  userSettingsSet: settings => dispatch(userSettingsSet(settings)),
  userSettingsUpdateRequest: (id, value) => dispatch(userSettingsUpdateRequest(id, value))
})

export default connect(mapStateToProps, mapDispatchToProps)(LayerToggle)